import { render } from "./ActivityBadgeCardPreview.vue?vue&type=template&id=dda33898&scoped=true"
import script from "./ActivityBadgeCardPreview.vue?vue&type=script&lang=js"
export * from "./ActivityBadgeCardPreview.vue?vue&type=script&lang=js"

import "./ActivityBadgeCardPreview.vue?vue&type=style&index=0&id=dda33898&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dda33898"]])

export default __exports__